import axios from 'axios'
import { calculateExpirationTime } from '@js/date-utils'
import { camelKeyToSnakeKeyRecursive } from '@js/str-utils'


const getDefaultState = () => {
  return {
    // Update: Renamed local storage keys for tokens.
    // New keys: 'access' and 'refresh' (previously 'access_token' and 'refresh_token')
    // For compatibility with existing users:
    // First, attempt to retrieve tokens using new keys from local storage.
    // If not found, fall back to retrieving with old keys.
    access: (
      localStorage.getItem('access') ||
      localStorage.getItem('access_token') ||
      null
    ),
    refresh: (
      localStorage.getItem('refresh') ||
      localStorage.getItem('refresh_token') ||
      null
    ),
    accessExpiresAt: localStorage.getItem('access_expires_at') || null,
    refreshExpiresAt: localStorage.getItem('refresh_expires_at') || null,
  };
};

const auth = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    accessTokenExpired: (state) => {
      if (!state.accessExpiresAt | !state.access) {
        return true;
      }
      return new Date().getTime() >= state.accessExpiresAt;
    },
    authorized: (state) => {
      return (
        state.refreshExpiresAt &&
        state.refresh &&
        new Date().getTime() < state.refreshExpiresAt
      );
    },
    refreshTokenExpired: (state) => {
      if (!state.refreshExpiresAt | !state.refresh) {
        return true;
      }
      return new Date().getTime() >= state.refreshExpiresAt;
    },
  },
  mutations: {
    clearAccessToken (state) {
      state.access = null;
      state.accessExpiresAt = null;
      localStorage.removeItem('access');
      localStorage.removeItem('access_expires_at');
    },
    clearRefreshToken (state) {
      state.refresh = null;
      state.refreshExpiresAt = null;
      localStorage.removeItem('refresh');
      localStorage.removeItem('refresh_expires_at');
    },
    initialize (state) {
      localStorage.removeItem('access');
      localStorage.removeItem('access_expires_at');
      localStorage.removeItem('refresh');
      localStorage.removeItem('refresh_expires_at');
      Object.assign(state, getDefaultState());
    },
    setAccessToken (state, tokenPair) {
      state.access = tokenPair.access;
      state.accessExpiresAt = calculateExpirationTime(tokenPair.accessExpiresIn);
      localStorage.setItem('access', state.access);
      localStorage.setItem('access_expires_at', state.accessExpiresAt);
      axios.defaults.headers.common['Authorization'] = state.access;
    },
    setRefreshToken (state, tokenPair) {
      state.refresh = tokenPair.refresh;
      state.refreshExpiresAt = calculateExpirationTime(tokenPair.refreshExpiresIn);
      localStorage.setItem('refresh', state.refresh);
      localStorage.setItem('refresh_expires_at', state.refreshExpiresAt);
    },
    setTokenPair (state, tokenPair) {
      this.commit('auth/setAccessToken', tokenPair);
      this.commit('auth/setRefreshToken', tokenPair);
    },
  },
};

export default auth;
